import { getUserRouteHistory } from './get-route-history';
import type { UserRouteHistory } from './types';

export function getReferrer(): string {
  const routeHistory = getUserRouteHistory();

  if (hasReferrer(routeHistory)) {
    return routeHistory[routeHistory.length - 2].asPath;
  } else {
    return '';
  }
}

const hasReferrer = (
  routeHistory: UserRouteHistory | null | undefined
): routeHistory is UserRouteHistory =>
  Array.isArray(routeHistory) &&
  routeHistory.length > 1 &&
  'asPath' in routeHistory[routeHistory.length - 2];
